class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.useInterval = this.getAttribute('data-use-change-interval');
      if (this.useInterval === "true") {
        this.interval = this.getAttribute('data-change-interval');
        this.firstSlide = document.querySelector('.hero-slider__slide');
        // this.slide();
        setInterval(this.slide.bind(this), this.interval);
      }
    }
    slide() {
        this.beforeSlide = document.querySelector('.hero-slider__slide--showing');
        if (this.beforeSlide) {
            this.beforeSlide.classList.remove('hero-slider__slide--showing');
            this.nextSlide = this.beforeSlide.nextElementSibling;
            if (this.nextSlide) {
                this.nextSlide.classList.add('hero-slider__slide--showing')
            } else {
                this.firstSlide.classList.add('hero-slider__slide--showing');
            }
        } else {
            this.firstSlide.classList.add('hero-slider__slide--showing');
        }
    }
  }
  
  customElements.define('hero-slider', HeroSlider);
  